export default __webpack_public_path__ + "static/media/financialsituation1Img1.6822c6ee.png";